export const SET_SMS_NUMBER = 'SET_SMS_NUMBER';

export const setSmsNumber = smsNumber => ({
  type: SET_SMS_NUMBER,
  value: {smsNumber},
});
